import { render, staticRenderFns } from "./configStockOne.vue?vue&type=template&id=63d61402&scoped=true"
import script from "./configStockOne.vue?vue&type=script&lang=js"
export * from "./configStockOne.vue?vue&type=script&lang=js"
import style0 from "./configStockOne.vue?vue&type=style&index=0&id=63d61402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d61402",
  null
  
)

export default component.exports